import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { css } from "@emotion/react"
import { useIntl } from "gatsby-plugin-react-intl"

const ProductNotice = () => {
    const intl = useIntl()

    const data = useStaticQuery(graphql`
        query {
            allContentfulShopSection {
                nodes {
                    notice {
                        childMarkdownRemark {
                            html
                        }
                    }
                }
            }
        }
    `)

    const content =
        intl.locale === "ja" ? data.allContentfulShopSection.nodes[0] : data.allContentfulShopSection.nodes[1]

    return (
        <div
            dangerouslySetInnerHTML={{
                __html: content.notice.childMarkdownRemark.html.replace(/\n/g, "<br>"),
            }}
            css={productDescStyle}
        />
    )
}
export default ProductNotice

const productDescStyle = css`
    padding-top: 10rem;
    p {
        font-size: 1.1rem;
        line-height: 1.45rem;
        color: gray;
    }
`
